(function () {
    'use strict';

    // js/features/contact-utils.js
    class ContactUtils {
        constructor(opts) {
            opts = opts || {};
            this.formId = opts.formId || 'contactForm';
            this.endpointUrl = opts.endpoint || '/message/send';
            this.btnId = opts.btnId || 'submitForm';
            this.honeypotId = opts.honeypotId || 'website';
            this.alertSuccessId = opts.alertSuccessId || 'alertSuccess';
            this.alertErrorId = opts.alertErrorId || 'alertError';
            this.alertSuccessMsgId = opts.alertSuccessMsgId || 'alertSuccessMsg';
            this.alertErrorMsgId = opts.alertErrorMsgId || 'alertErrorMsg';
            this.btnIconId = opts.btnIconId || 'btnIcon';
            this.btnTextId = opts.btnTextId || 'btnText';

            this.errors = {
                name: 'nameError',
                email: 'emailError',
                subject: 'subjectError',
                message: 'messageError'
            };
        }

        init() {
            var form = this.getEl(this.formId);
            if (!form) return;
            var self = this;
            form.addEventListener('submit', function (e) { self.onSubmit(e); });
        }

        endpoint() { return this.endpointUrl; }

        // --- DOM helpers (no optional chaining) ---
        getEl(id) { return document.getElementById(id); }

        show(id) {
            var el = this.getEl(id);
            if (el) el.classList.remove('hidden');
        }

        hide(id) {
            var el = this.getEl(id);
            if (el) el.classList.add('hidden');
        }

        setText(id, text) {
            var el = this.getEl(id);
            if (el) el.textContent = text;
        }

        toggleError(id, show) {
            var el = this.getEl(id);
            if (!el) return;
            if (show) el.classList.remove('hidden'); else el.classList.add('hidden');
        }

        loading(on) {
            var btn = this.getEl(this.btnId);
            var icon = this.getEl(this.btnIconId);
            var text = this.getEl(this.btnTextId);
            if (btn) btn.disabled = !!on;
            if (text) text.textContent = on ? 'Sending...' : 'Send Message';
            if (icon) {
                if (on) icon.classList.add('animate-pulse'); else icon.classList.remove('animate-pulse');
            }
        }

        // Works with or without jQuery present
        val(id) {
            if (window.$ && typeof window.$ === 'function') {
                var jq = window.$('#' + id);
                if (jq && jq.length) return (jq.val() || '').toString().trim();
            }
            var el = this.getEl(id);
            return el && typeof el.value === 'string' ? el.value.trim() : '';
        }

        serialize() {
            return {
                name: this.val('name'),
                email: this.val('email'),
                subject: this.val('subject'),
                message: this.val('message'),
                _hp: this.val(this.honeypotId) // honeypot
            };
        }

        validate(payload) {
            var name = payload.name;
            var email = payload.email;
            var subject = payload.subject;
            var message = payload.message;
            var hp = payload._hp;

            var emailOk = /^\S+@\S+\.\S+$/.test(email);
            this.toggleError(this.errors.name, !name);
            this.toggleError(this.errors.email, !emailOk);
            this.toggleError(this.errors.subject, !subject);
            this.toggleError(this.errors.message, !message);

            if (hp) return false; // honeypot caught
            return !!(name && emailOk && subject && message);
        }

        async postJson(url, body, extraHeaders) {
            extraHeaders = extraHeaders || {};
            var headers = { 'Content-Type': 'application/json' };
            for (var k in extraHeaders) headers[k] = extraHeaders[k];

            const res = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                credentials: 'same-origin'
            });

            let data = null;
            try { data = await res.json(); } catch (e) {} // non-JSON is fine

            if (!res.ok) {
                const msg = (data && data.message) ? data.message : ('HTTP ' + res.status);
                const err = new Error(msg);
                err.status = res.status;
                err.payload = data;
                throw err;
            }
            return data;
        }

        async onSubmit(e) {
            e.preventDefault();
            this.hide(this.alertSuccessId);
            this.hide(this.alertErrorId);

            var payload = this.serialize();
            if (!this.validate(payload)) return;

            this.loading(true);
            try {
                const data = await this.postJson(this.endpoint(), {
                    name: payload.name,
                    email: payload.email,
                    subject: payload.subject,
                    message: payload.message
                });
                this.setText(this.alertSuccessMsgId, (data && data.message) ? data.message : 'Thanks for reaching out — we’ll get back to you soon.');
                this.show(this.alertSuccessId);

                var form = this.getEl(this.formId);
                if (form) form.reset();
            } catch (err) {
                console.error('Contact send failed:', err);
                this.setText(this.alertErrorMsgId, err && err.message ? err.message : 'Please try again in a moment.');
                this.show(this.alertErrorId);
            } finally {
                this.loading(false);
            }
        }
    }

    new ContactUtils({
        endpoint: '/message/send'
    }).init();

}());
